<template>
  <div class="table">
    <el-table
      :data="leaveTypeSettingsData"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text="You are yet to create a leave type setting"
      v-loading="loading"
    >
      <div slot="empty">
        <NoDataToView
          v-if="!loading"
          link="/admin/hrm/leave/settings/leave-type/create"
          :showButton="showCreateLeaveTypeLink"
          btnText="Leave Type"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateLeaveTypeLink"
                @click="$emit('resetTable')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        sortable
        prop="id"
        label="ID"
        width="100"
      ></el-table-column>
      <el-table-column
        sortable
        prop="leave_name"
        label="LEAVE TYPE"
      ></el-table-column>
      <el-table-column
        sortable
        prop="applicable_days"
        label="NO OF DAYS"
      ></el-table-column>
      <el-table-column sortable prop="is_paid" label="PAID LEAVE" width="140">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_paid === false ? 'danger' : 'success'">
            {{ scope.row.is_paid === false ? "No" : "Yes" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template slot-scope="scope">
          <div class="actions">
            <button @click="$emit('toggleView', scope.row)">
              <img src="/img/view.svg" alt="view" />
            </button>
            <button @click="editLeaveType(scope.row.id)">
              <img src="/img/pencil-edit.svg" alt="edit" />
            </button>
            <button @click="deleteALeaveType(scope.row.id)">
              <img src="/img/delete.svg" alt="delete" />
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeType"
        @current-change="handleCurrentChangeType"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");
import NoDataToView from "@/components/general/NoDataToView";

export default {
  components: {
    NoDataToView,
  },
  props: ["resetTable", "searchQuery"],
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  mounted() {
    this.getLeaveTypes();
  },
  computed: {
    ...mapState({
      leaveTypeSettingsData: "leaveTypes",
      total: "leaveTypeTotal",
      perPage: "perPage",
    }),
    showCreateLeaveTypeLink() {
      return !this.searchQuery && !this.leaveTypeSettingsData.length;
    },
    noDataMessage() {
      let message = `No Leave Type available`;
      if (this.showCreateLeaveTypeLink) {
        return message;
      }
      return `${message} ${this.searchQuery ? "for " : ""} ${
        this.searchQuery
      } `;
    },
    loading: {
      get() {
        return this.$store.state.admin.tableLoading;
      },
      set(value) {
        return this.$store.commit("admin/tableLoading", value);
      },
    },
    currentPage: {
      get() {
        return this.$store.state.admin.hrm.leave.currentPage;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/currentPage", value);
      },
    },
  },
  methods: {
    ...mapActions([
      "handleSizeChangeType",
      "handleCurrentChangeType",
      "deleteLeaveType",
    ]),
    getLeaveTypes() {
      this.$store
        .dispatch("admin/hrm/leave/getLeaveTypes")
        .then(() => {})
        .catch(error => {
          this.$notification.error(error.message, { offset: 100 });
        });
    },
    toggleView() {
      this.$emit("toggleView");
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    editLeaveType(id) {
      this.$router.push({ name: "edit-leaveType", params: { id } });
    },
    deleteALeaveType(id) {
      this.$promptModal(
        "Delete Leave Type",
        "This Leave type will be deleted",
        "Delete",
        () => this.handleDeleteLeaveType(id)
      );
    },
    handleDeleteLeaveType(id) {
      this.loading = true;
      this.deleteLeaveType(id)
        .then(() => {
          this.loading = false;
          this.getLeaveTypes();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
  },
};
</script>
